import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const gmpPostRejectWorkflow = createApi(`GMPRejectWorkflowSlice`,"POST");

const GMPRejectWorkflowSlice = createSlice({
  name: 'GMPRejectWorkflowSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(gmpPostRejectWorkflow.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gmpPostRejectWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(gmpPostRejectWorkflow.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPRejectWorkflowSlice.reducer;